import { render, staticRenderFns } from "./ScoringStep.vue?vue&type=template&id=3695795e&scoped=true"
import script from "./ScoringStep.vue?vue&type=script&lang=js"
export * from "./ScoringStep.vue?vue&type=script&lang=js"
import style0 from "./ScoringStep.vue?vue&type=style&index=0&id=3695795e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695795e",
  null
  
)

export default component.exports